import unauthenticatedHttp from "@/services/unauthenticatedHttp";

export async function certification(id: string) {
  await unauthenticatedHttp().get(
    `${globalThis.env.API_UNAUTH}/certifications/${id}`
  );
}

export async function certifications() {
  await unauthenticatedHttp().get(
    `${globalThis.env.API_UNAUTH}/certifications`
  );
}

export async function fetchUnauthCertification(id: any) {
  const { data } = await unauthenticatedHttp().get(
    `${globalThis.env.API_UNAUTH}/certifications/${id}`
  );
  return data;
}
